import React from 'react';
import ReactDOM from 'react-dom';
import { CSSTransitionGroup } from 'react-transition-group';
import propTypes from 'prop-types';
import './index.css';

H5Picker.propTypes = {
  active: propTypes.number.isRequired,
  setActive: propTypes.func.isRequired,
  handleConfirm: propTypes.func.isRequired,
  handleClose: propTypes.func.isRequired,
};

function H5Picker(props){
  let { active, list } = props;
  let { handleClose, handleConfirm, setActive } = props;
  return (
    <section className="H5Picker-box">
      <div className="H5Picker-mask" onClick={handleClose}></div>
      <div className="H5Picker-content">
        <header className="H5Picker-title">
          <div className="confirm-btn" onClick={handleConfirm}>完成</div>
        </header>
        <div className="H5Picker-body">
          <ul className="H5Picker-list">
            {
              list.map((pick, index)=>{
                return (<li 
                  key={index} 
                  className={`${active == index ? 'active' : ''} inner-item`}
                  onClick={()=>{
                    setActive(index);
                  }}>
                  <p className="city-name">{pick.text}</p>
                </li>);
              })
            }
          </ul>
        </div>
      </div>
    </section>
  );
}



export default class H5PickerContainer extends React.Component{
  constructor(props){
    super();
    this.state = {
      showH5Picker: false,
      activeIndexs: null
    };
  }
  render(){
    let { showH5Picker, activeIndexs, list} = this.state;
    return(
      <CSSTransitionGroup
        component="div"
        className="H5Picker-box-wrap"
        transitionName="H5Picker-box"
        transitionEnterTimeout={350}
        transitionLeaveTimeout={350}>
        {
          showH5Picker ?
            <H5Picker
              active={activeIndexs[0]}
              list={list}
              setActive={this.setActive}
              handleClose={this.hide}
              handleConfirm={this.handleConfirm}
            />
            : null
        }
      </CSSTransitionGroup>
    );
  }

  setActive = (index)=>{
    this.setState({
      activeIndexs: [index]
    });
  }

  show = (props)=>{
    this.setState({
      ...props,
      showH5Picker: true
    });

    this._handleConfirm = props.handleConfirm;
  }

  hide = (props)=>{
    this.setState({
      showH5Picker: false
    });
  }

  handleConfirm = ()=>{
    let { activeIndexs } = this.state;
    this._handleConfirm(activeIndexs);
    this.setState({
      showH5Picker: false
    });
  }
}




export function show(props) {
  let instance = getInstance();

  instance.show(props);
}

export function hide() {
  let instance = getInstance();
  instance.hide();
}


function getContainerNode() {
  if (getContainerNode.node) {
    return getContainerNode.node;
  }

  let node = getContainerNode.node = document.createElement('div');
  node.className = 'H5Picker';
  document.body.appendChild(node);

  return node;
}

function getInstance() {
  if (getInstance.instance) {
    return getInstance.instance;
  }

  let node = getContainerNode();

  getInstance.instance = ReactDOM.render(<H5PickerContainer />, node);
  return getInstance.instance;
}



// WEBPACK FOOTER //
// ./src/components/H5Picker/index.js